<div class="background-overlay" [style.backgroundImage]="imageUrl() | backgroundImgSet">
    <div class="background-overlay__darken"></div>
    <div class="background-overlay__contrast"></div>
    <div class="background-overlay__content">
        <ng-content />
    </div>

    <div class="background-overlay__footer">
        <ng-content select="[footer]"></ng-content>
    </div>
</div>
